import { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import Button from "../../components/Button";
import ExitButton from "../../components/ExitButton";
import authFetch from "../../api/authFetch";
//import Overview from "../course/components/Overview";

const NewAssignment = ({successHandler, tag, teacher = ""}) => {
    const {setAuth} = useAuth();
    const [levels, setLevels] = useState([]);
    const [level, setLevel] = useState("");
    const [exercises, setExercises] = useState([]);
    const [addedExercises, setAddedExercises] = useState([]);
    const [title, setTitle] = useState("");

    const fetchData = async (route, method, body = null) => {
        let meta = {
            method: method
        }
        if (body) {
            meta.body = JSON.stringify(body);
        }
        const response = await authFetch(`/teacher/${route}` + ((teacher !== "") ? `?teacher_name=${teacher}` : ""), meta);
        if (response.status === 401) {
            localStorage.removeItem("token");
            setAuth({});
            return null;
        }
        if (response.ok) {
            const json = await response.json();
            return json;
        }
        return null
    }

    const getLevels = async () => {
        const json = await fetchData(`exercise-levels/${tag}`, "GET");
        if (json) {
            setLevels(json);
        }
    }

    const getExercises = async () => {
        if (level !== "") {
            const json = await fetchData(`exercises/${tag}/${level}`, "GET");
            if (json) {
                setExercises(json);
            }
        }
    }
    
    const addExercise = (exercise) => {
        setAddedExercises([...addedExercises, exercise]);
    }

    const removeExercise = (exercise) => {
        let array = [...addedExercises];
        const i = addedExercises.indexOf(exercise);
        array.splice(i, 1);
        setAddedExercises(array);
    }

    const postAssignment = async () => {
        await fetchData(`assignment/${tag}`, "POST", {
            title: title,
            exercises: addedExercises
        });
        successHandler(false);
    }

    useEffect(() => {getLevels()}, []);
    useEffect(() => {getExercises()}, [level]);

    return (
        <main className="page-shell">
            <div className="page-container">
            <div className="page-header">
                <ExitButton func={()=> {successHandler(false)}} />
                <div>
                    <p className="panel-heading">Class assignment</p>
                    <h1 className="page-heading">Create an assignment</h1>
                    <p className="page-subtitle">Select a level, add exercises, and give the assignment a title.</p>
                </div>
            </div>
            <div className="assignment-grid">
                {level === "" &&
                    <section className="panel class-panel">
                        <div className="flex items-center justify-between">
                            <h2 className="panel-heading">1. Choose a level</h2>
                            <span className="status-pill">{levels.length}</span>
                        </div>
                        <div className="selection-list">
                            {levels.map(level => {
                                return <Button key={level} text={level} func={() => {setLevel(level)}} variant="secondary" className="w-full" />
                            })}
                            {levels.length === 0 && <div className="empty-state">No levels are available for this class.</div>}
                        </div>
                    </section>
                }
                {level !== "" &&
                    <section className="panel class-panel">
                        <div className="flex items-center justify-between gap-3">
                            <div>
                                <h2 className="panel-heading">1. Exercises</h2>
                                <div className="mt-1 font-bold text-cyan-950">{level}</div>
                            </div>
                            <Button text="Change level" func={() => setLevel("")} variant="ghost" />
                        </div>
                        <div className="selection-list">
                            {exercises.map(exercise => {
                                return <div className="list-row" key={exercise}>
                                    <div className="min-w-0 truncate font-semibold">{exercise}</div>
                                    {addedExercises.includes(exercise) &&
                                        <Button text="Remove" func={() => removeExercise(exercise)} variant="ghost"/>
                                    }
                                    {!addedExercises.includes(exercise) &&
                                        <Button text="Add" func={() => addExercise(exercise)} />
                                    }
                                </div>
                            })}
                            {exercises.length === 0 && <div className="empty-state">No exercises are available at this level.</div>}
                        </div>
                    </section>
                }
                <section className="panel class-panel">
                    <div className="flex items-center justify-between">
                        <h2 className="panel-heading">2. Selected exercises</h2>
                        <span className="status-pill">{addedExercises.length}</span>
                    </div>
                    <div className="selection-list">
                        {addedExercises.map(exercise => {
                            return <div className="list-row" key={exercise}>
                                <div className="min-w-0 truncate font-semibold">{exercise}</div>
                                <Button text="Remove" func={() => removeExercise(exercise)} variant="ghost"/>
                            </div>
                        })}
                        {addedExercises.length === 0 && <div className="empty-state">Exercises you add will appear here.</div>}
                    </div>
                </section>
                <section className="panel class-panel">
                    <form
                        className="panel-stack h-full"
                        onSubmit={(event) => {
                            event.preventDefault();
                            postAssignment();
                        }}
                    >
                    <h2 className="panel-heading">3. Assignment details</h2>
                    <label className="flex flex-col gap-2">
                        <span className="account-label">Title</span>
                        <input className="form-field" type="text" value={title} placeholder="Assignment title" onChange={e => setTitle(e.target.value)} />
                    </label>
                    <Button
                        className="mt-auto"
                        text="Publish assignment"
                        type="submit"
                        clickable={title !== "" && addedExercises.length > 0}
                    />
                    </form>
                </section>
            </div>
            </div>
        </main>
    )
}

export default NewAssignment;
